import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MainLayout } from './layout/main-layout';

/**
 * Composant racine. Monte le shell applicatif (MainLayout), qui contient
 * lui-meme le <router-outlet/> dans sa zone de contenu.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MainLayout],
  template: `<app-main-layout />`,
})
export class App {}
